

import React, { Component, useEffect, useState } from "react";
import joi from "joi";
import { Modal, Container, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
// import EquipmentType from './../EquipmentType/EquipmentType';
import swal from "sweetalert";
import validation from "../../../src/utill/validation";
import { Row, Space } from "antd";
import axios from "axios";
import api from "../../../src/config.json";
import Table from "../../../src/Common/table";
import dateTime from "../../../src/utill/dateTime";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Excelimport from "../../../src/utill/Excelimport";
import Loading from "../../../src/utill/LoadingComponent";
import { Select as AntdSelect } from "antd";
import { QRCodeSVG } from "qrcode.react";
import XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import _ from "lodash";
import { generateExcelFile } from "../../utill/download";
import moment from "moment";
import DownloadExcelByTableId from "../../utill/ExcelMultipleWorkSheets";

const TracibilityReport1 = ({ RightName, getRightsForAccess, Heading }) => {
  const [sortColumn, setSortColumn] = useState({ path: 'PartID', order: 'asc' });
  const [Inputdata, setInputData] = useState({});
  const [Inputdata1, setInputData1] = useState({});

  const [FIELDName, setFIELDName] = useState('');
  const [tabledata, settabledata] = useState([
    
    ]);
  const [loader, setLoader] = useState(false);
  const [templateList, setTemplateList] = useState([{Name:'Traceability Number',value:'Traceability Number'},{Name:'Batch Code',value:'Batch Code'}]);
  const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] });
  const [errors, seterrors] = useState({});
  const [DataList, setDataList] = useState([]);
  const [tableids, settableIds] = useState([]);

  
  console.log(Inputdata,"vsfdhbsd")
  const [columns6, setColumns6] = useState([
    // { path: "ChemicalMixDate", label: "Chemical Mix Date" },
  
    { path: "Reservoir_ID", label: "Reservoir ID" },
    { path: "RawMaterialID", label: "Raw Material Id" },
    { path: "Vendor", label: "Vendor" },
    { path: "InvoiceDate", label: "Invoice Date" ,content: obj => <React.Fragment>
            <label>
             {obj.InvoiceDate && moment(obj.InvoiceDate).format('DD-MM-YYYY')}
            </label>
          </React.Fragment>
      },
    { path: "InvoiceNo", label: "Invoice No" },

 
   
]);

{console.log(tableids,"current activation")}

const [columns, setColumns] = useState([
  
    { path: "Reservoir_ID", label: "Reservoir ID" },
    { path: "RawMaterialID", label: "Raw Material Id" },
    { path: "Vendor", label: "Vendor" },
    { path: "InvoiceDate", label: "Invoice Date" ,content: obj => <React.Fragment>
            <label>
             {obj.InvoiceDate && moment(obj.InvoiceDate).format('DD-MM-YYYY')}
            </label>
          </React.Fragment>
      },
    { path: "InvoiceNo", label: "Invoice No" },

 
   
]);
const [columns2, setColumns2] = useState([
  { path: "RawMaterialID", label: "Raw Material Id" },
  { path: "Vendor", label: "Vendor" },
  { path: "InvoiceDate", label: "Invoice Date" ,content: obj => <React.Fragment>
          <label>
           {moment(obj.InvoiceDate).format('DD-MM-YYYY')}
          </label>
        </React.Fragment>
    },
  { path: "InvoiceNo", label: "Invoice No" },


 
]);
const [columns4, setColumns4] = useState([
  { path: "Kneader_ID", label: "Kneader ID" },
  { path: "KneaderAt", label: "Kneader At" ,content: obj => <React.Fragment>
          <label>
           {obj.KneaderAt && moment(obj.KneaderAt).format('DD-MM-YYYY hh:mm a')}
          </label>
        </React.Fragment>
    },
    // { path: "BatchCode", label: "Batch Code" },
    { path: "TotalGreenSheetsQtyProduced", label: "Qty produced (kg)" },
    { path: "GreenSheetAvailable", label: "Qty Available (kg)" },


 
]);
const [columns1, setColumns1] = useState([
  { path: "Date", label: "Date",content: obj => <React.Fragment>{moment(obj.DateTime).format('DD-MM-YYYY')}</React.Fragment>},
  { path: "Time", label: "Time",content: obj => <React.Fragment>{moment(obj.DateTime).format('hh:mm a')}</React.Fragment> },
  { path: "ToolId", label: "Tool ID" },
  { path: "BatchCode", label: "Batch Code" },

  { path: "TracebilityNo", label: "Traceability Number" },
  { path: "Qty", label: "Qty" },
  { path: "Result", label: "Result" },



]);
const [columns5, setColumns5] = useState([
  { path: "TracebilityNo", label: "Traceability Number" },
  { path: "MixingDate", label: "Mixing Date",content: obj => <React.Fragment>{obj.MixingDate && moment(obj.MixingDate).format('DD-MM-YYYY')}</React.Fragment> },
  { path: "ExpiryDate", label: "Use By",content: obj => <React.Fragment>{obj.ExpiryDate && moment(obj.ExpiryDate).format('DD-MM-YYYY')}</React.Fragment>},
  { path: "BatchCode", label: "Batch Code" },
  { path: "CompoundCode", label: "Compound Code" },
  { path: "Qty", label: "Qty (kg)" },
  { path: "NumOfStickers", label: "Num Of Stickers" },
]);













  useEffect(() => {

    Heading("Trace by B/C ; T/N");
    // getToolList();
  }, []);


  const getBatchList = () => {
    axios
      .get(api.api + "FetchBatchCodes")
      .then((result) => {
        if(result.data.length > 0){
console.log(result.data,"bgjkndkjf")
          

          const list = result.data.map(one=>({Name: one,value: one}))
          setDataList(list);
        }else{
          swal('No Batch Found');
        }
        
      })
      .catch((err) => {
        setDataList([]);

        console.log(err);
      });
  };

  const handleSort = sortColumn => {
    if (tabledata.length > 0) {
      const sorted = _.orderBy(tabledata, [sortColumn.path], [sortColumn.order]);
      setSortColumn(sortColumn)
      settabledata(sorted)
    }
  }

  const schema = {
    TraceBy: joi.string().required(),
    _id: joi.string(),
  };
  const handleDownloadExcel = (e) => {
    generateExcelFile(e);
  };
  
  const handleOnChange1 = (e) => {
    const { name, value } = e.currentTarget;
if(name ==='TraceBy' && value ==='Traceability Number'){
  setFIELDName('Tracibility Number')

  setInputData1((prev) => ({
    ...prev,
    [name]: value,
  }));
}else{
  setFIELDName('Batch Code')
  setInputData1((prev) => ({
    ...prev,
    [name]: value,
  }));
}

   
  };
  const handleOnChange = (e) => {
    const { name, value } = e.currentTarget;



setInputData({[name]:value})
  };
  const getComponentCodeMaster = () => {
    axios
      .get(api.api + "compoundCode")
      
      .then((result) => {

        if(result.data.length > 0){
          const data = _.uniqBy(result.data, "TracebilityNo");

          const list = data.map(one=>({Name: one.TracebilityNo,value: one.TracebilityNo}))
          setDataList(list);
        }else{
          swal('No Traceability No found');
        }
        
      })
      .catch((err) => {
        setDataList([]);

        console.log(err);
      });
  };
  const handelGetData = (data) => {
    // return
    const checksheet = { ...data };
  
    // const errors = validation.validate(checksheet, schema);
    // if (errors) {
    //   seterrors(errors);
    //   return;
    // }
    setLoader(true);
   
      axios
        .post(api.api + "report1", checksheet)
        .then((result) => {
          // getToolList();
      console.log(result.data,'api data recived')
      if(result.data.length > 0) {
        settabledata(result.data)

      }else{
        swal('No data available');

      }
          setLoader(false);
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    
  };
  return (
    <>
     
      {loader ? <Loading /> : <></>}
      <div className="">
  <Row className="">
    <Col sm={3}>
      <div className="form-group ">
        <label htmlFor="operationRejectionCost " className="m-0">Trace By</label>
        <AntdSelect
          placeholder="Trace By"
          onChange={(value) => {
            // const template = templateList.find((x) => x.Name == value);
            // setSelectedTemplate(template || {});
            handleOnChange1({
              currentTarget: { name: "TraceBy", value: value },
            });
          }}
          value={Inputdata1.TraceBy || []}
          style={{ width: "100%" }}
        >
          {templateList.map((one) => {
            return (
              <AntdSelect.Option key={one.Name} value={one.Name}>
                {one.Name}
              </AntdSelect.Option>
            );
          })}
        </AntdSelect>
        {errors.TraceBy && (
          <div className="alert small alert-danger">
            {errors["TraceBy"]}
          </div>
        )}
      </div>
    </Col>
    {FIELDName && <Col sm={3}>
    <div className="form-group form-group-sm d-flex flex-column">
                <label htmlFor="operationRejectionCost" className="m-0">
                  
                  {FIELDName}
                </label>
                <input
                  required
                  onChange={handleOnChange}
                  //disabled={cycleTimeRadioState === 1 ? false : true}
                  className="form-control form-control-sm w-100 m-0"
                  type="text"
                  name={FIELDName =='Tracibility Number' ?'TracibilityNumber':'BatchCode'|| ''}
                  value={Inputdata[FIELDName =='Tracibility Number' ?'TracibilityNumber':'BatchCode']|| ''}
                  
                  // value={Inputdata[FIELDName] ||''}
                  placeholder={'Enter ' +FIELDName}

                />
                {errors.FIELDName && (
                  <div className="alert small alert-danger">
                    {errors[FIELDName]}
                  </div>
                )}
              </div>
      {/* <div className="form-group ">
        <label htmlFor="operationRejectionCost " className="m-0">{FIELDName}</label>
        
        <AntdSelect
         showSearch // Enables the search functionality
         filterOption={(input, option) =>
           option?.children.toLowerCase().includes(input.toLowerCase())
         } 
          placeholder={FIELDName}
          onChange={(value) => {
            // const template = templateList.find((x) => x.Name == value);
            // setSelectedTemplate(template || {});
            handleOnChange({
              currentTarget: { name: FIELDName =='Tracibility Number' ?'TracibilityNumber':'BatchCode', value: value },
            });
          }}
          value={Inputdata[FIELDName =='Tracibility Number' ?'TracibilityNumber':'BatchCode']|| []}
          style={{ width: "100%" }}
        >
          {DataList.map((one) => {
            return (
              <AntdSelect.Option key={one.Name} value={one.Name}>
                {one.Name}
              </AntdSelect.Option>
            );
          })}
        </AntdSelect>
        {errors.TraceBy && (
          <div className="alert small alert-danger">
            {errors["TraceBy"]}
          </div>
        )}
      </div> */}
    </Col>}
    <Col sm={1} className="py-4">
      <button
        // disabled={!getRightsForAccess("StaticDataRights", RightName, "write")}
        className="btn-sm btn-primary "
        onClick={() => {
          handelGetData(Inputdata)
        }}
      >
    
        Apply
      </button>
    </Col>
    <Col sm={2} className="py-4">
    {tabledata && tabledata.length > 0 ? (<DownloadExcelByTableId name={'Download Report'} tableIds={ _.uniq(tableids)} />):''}

    </Col>
  
  </Row>
</div>

<div className="">

{console.log(tabledata,"vdfjvnfdivb")}
      {tabledata && tabledata.length < 0 ? (
          "Data Not Available"
        ) : (tabledata.map(one =><div className=""
        >


          {/* {one && one.ChemicalInventory  &&<div className=""
          >
       <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px'}}>Compound Code : {one.CompoundCode}</p>

       <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px'}}>Kneader ID : {one.RollerID}</p>
        <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px'}}>Date Time : {one.ActivatedAt}</p>
        <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px'}}>Qty : {one.Qty}</p>
        <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px'}}>StorageLocation  : {one.StorageLocation}</p>
          <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px'}}>Chemical Inventory :</p>
        <Table
        id="tracibilityreport1"
        columns={columns}
        onSort={handleSort}
        sortColumn={sortColumn}
        data={one.chemicalCheckpoints}
        />
        </div>} */}
        <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px',fontWeight:'700'}}>Chemical Mix - Chemical Inventory:</p>
       <div className=" border  p-2 rounded mt-2"> { [...one.chemicalCheckpoints].sort((a, b) => a.DateTime.localeCompare(b.DateTime)).map((item,index)=> {
         tableids.push(`${'chemicalmixchemicalinventory'+(index+1)}`)
         if(one.chemicalCheckpoints.length == index+1){
         tableids.push("kneading")

         }
        return<>
   <p
  className="p-0 m-0 text-black"
  style={{ fontWeight: '400', fontSize: '15px' }}
>
  Chemical Mix Date Time:{" "}
  {item.DateTime
    ? item.DateTime.includes(",")
      ? item.DateTime.split(",").map((item1, index) => (
          <span key={index}>
            {moment(item1.trim()).format("DD-MM-YYYY hh:mm a")}
            {index < item.DateTime.split(",").length - 1 && ", "}
          </span>
        ))
      : moment(item.DateTime).format("DD-MM-YYYY hh:mm a")
    : "N/A"}
</p>

     <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px',fontWeight:'400'}}>Count : {item.Count && item.Count} </p>

       <Table
        id={`${'chemicalmixchemicalinventory'+(index+1)}`}
        columns={columns6}
        onSort={handleSort}
        sortColumn={sortColumn}
        data={ [...item.ChemicalMixCheckpoints].sort((a, b) => a.Reservoir_ID.localeCompare(b.Reservoir_ID))}
        />
         </>})}</div>
      

        <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px',fontWeight:'700'}}>Kneading:</p>
       
       
        <Table
    id="kneading"
    columns={columns4}
    onSort={handleSort}
    sortColumn={sortColumn}
    data={[...one.kneaderArr].sort((a, b) => a.KneaderAt.localeCompare(b.KneaderAt))} // Spread `one` and update `KneaderAt` with the current `time`
/>



       
         <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px',fontWeight:'700'}}>Oil Inventory :</p>
        {/* <Table
        id="oil-inventory"
        columns={columns}
        onSort={handleSort}
        sortColumn={sortColumn}
        data={one.oilCheckpoints}
        /> */}
         <div className=" border  p-2 rounded mt-2"> {[...one.oilCheckpoints].sort((a, b) => a.DateTime.localeCompare(b.DateTime)).map((item,index)=> { 
          tableids.push(`${'oli-inventory-logs'+(index+1)}`)
          return<>
     <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px',fontWeight:'400'}}>  Date Time :  {item.DateTime
    ? item.DateTime.includes(",")
      ? item.DateTime.split(",").map((item1, index) => (
          <span key={index}>
            {moment(item1.trim()).format("DD-MM-YYYY hh:mm a")}
            {index < item.DateTime.split(",").length - 1 && ", "}
          </span>
        ))
      : moment(item.DateTime).format("DD-MM-YYYY hh:mm a")
    : "N/A"} </p>
     <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px',fontWeight:'400'}}>Count : {item.Count && item.Count} </p>

       <Table
        id={`${'oli-inventory-logs'+(index+1)}`}
        columns={columns}
        onSort={handleSort}
        sortColumn={sortColumn}
        data={
          [...item.OilsCheckpoints].sort((a, b) => a.Reservoir_ID.localeCompare(b.Reservoir_ID)) }
        />
         </>})}</div>
         <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px',fontWeight:'700'}}>Carbon Inventory :</p>
         <div className=" border  p-2 rounded mt-2"> {[...one.carbonCheckpoints].sort((a, b) => a.DateTime.localeCompare(b.DateTime)).map((item,index)=> {
     tableids.push(`${'carboninventorylogs'+(index+1)}`)

     return    <>
     <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px',fontWeight:'400'}}>  Date Time :  {item.DateTime
    ? item.DateTime.includes(",")
      ? item.DateTime.split(",").map((item1, index) => (
          <span key={index}>
            {moment(item1.trim()).format("DD-MM-YYYY hh:mm a")}
            {index < item.DateTime.split(",").length - 1 && ", "}
          </span>
        ))
      : moment(item.DateTime).format("DD-MM-YYYY hh:mm a")
    : "N/A"} </p>
     <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px',fontWeight:'400'}}>Count : {item.Count && item.Count} </p>

       <Table
        id={`${'carboninventorylogs'+(index+1)}`}
        columns={columns}
        onSort={handleSort}
        sortColumn={sortColumn}
        data={
          [...item.CarbonCheckpoints].sort((a, b) => a.Reservoir_ID.localeCompare(b.Reservoir_ID)) 
        }
        />
         </>})}</div>
         <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px',fontWeight:'700'}}>Others -  Inventory:</p>
       <div className=" border  p-2 rounded mt-2"> { [...one.othersCheckPoints].sort((a, b) => a.DateTime.localeCompare(b.DateTime)).map((item,index)=> {
     tableids.push(`${'othersinventorylogs'+(index+1)}`)
     if(one.othersCheckPoints.length == index+1){
      tableids.push("polymerused")

      }
        return <>
     <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px',fontWeight:'400'}}> Date Time :  {item.DateTime
    ? item.DateTime.includes(",")
      ? item.DateTime.split(",").map((item1, index) => (
          <span key={index}>
            {moment(item1.trim()).format("DD-MM-YYYY hh:mm a")}
            {index < item.DateTime.split(",").length - 1 && ", "}
          </span>
        ))
      : moment(item.DateTime).format("DD-MM-YYYY hh:mm a")
    : "N/A"} </p>
     <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px',fontWeight:'400'}}>Count : {item.Count && item.Count} </p>

       <Table
        id={`${'othersinventorylogs'+(index+1)}`}
        columns={columns6}
        onSort={handleSort}
        sortColumn={sortColumn}
        data={
          [...item.OthersCheckpoints].sort((a, b) => a.Reservoir_ID.localeCompare(b.Reservoir_ID)) 

        }
        />
         </>})}</div>
        {/* <Table
        id="carbon-inventory"
        columns={columns}
        onSort={handleSort}
        sortColumn={sortColumn}
        data={one.carbonCheckpoints}
        /> */}
         <p className ="p-0 m-0 text-black "style={{fontWeight:'200', fontSize:'15px',fontWeight:'700'}}>Polymer Used :</p>
        <Table
        id="polymerused"
        columns={columns2}
        onSort={handleSort}
        sortColumn={sortColumn}
        data={[one.Polymer]}
        />
         
        <div className="border  p-2 rounded mt-2">

          
        <p className ="p-0 m-0 text-black "style={{fontWeight:'200', fontSize:'15px',fontWeight:'700'}}>Activation :</p>
        {one.Activation && [...one.Activation].sort((a, b) => a.From_SrNo - b.From_SrNo).map((data,indx)=>{
          tableids.push(`${"Activationchemicalinventory"}`+indx+1)
          if(one.Activation.length == indx+1){
           tableids.push("traceability")
           tableids.push("traceabilitylogs")

     
           }
          return <div className=" border  p-2 rounded mt-2">
        <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px'}} >Sheet Serial : {data.From_SrNo}</p>
        <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px'}}>Date Time : { data.ActivatedAt && moment(data.ActivatedAt).format('DD-MM-YYYY hh:mm a')}</p>
        <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px'}}>Mixing Mill : {data.MixingMill}</p>
        <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px'}}>Mfg : {data.DateOfMfg && moment(data.DateOfMfg).format('DD-MM-YYYY')}</p>
        <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px'}}>Use By : {data.UseBy && moment(data.UseBy).format('DD-MM-YYYY')}</p>
        <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px'}}>Qty (kg): {data.QtyProduced}</p>
        <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px'}}>Unique ID : {data.UniqueID}</p>

        <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px',fontWeight:'700'}}>Chemical Inventory  :</p>
        <Table
        id={`${"Activationchemicalinventory"}`+indx+1}
        columns={columns}
        onSort={handleSort}
        sortColumn={sortColumn}
        data={
          [...data.ChemicalMixCheckpoint].sort((a, b) => a.Reservoir_ID.localeCompare(b.Reservoir_ID)) 

        }
        />
           </div>})}
        </div>
        
        
        {one.TracebilityMaster && <>
        <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px',fontWeight:'700'}}>Traceability :</p>
        <Table
        id="traceability"
        columns={columns5}
        onSort={handleSort}
        sortColumn={sortColumn}
        data={
          [...one.TracebilityMaster].sort((a, b) => a.MixingDate.localeCompare(b.MixingDate)) 

        }
        />
        </>
        }


        <p className ="p-0 m-0 text-black"style={{fontWeight:'200', fontSize:'15px',fontWeight:'700'}}>Traceability Logs :</p>
        <Table
        id="traceabilitylogs"
        columns={columns1}
        onSort={handleSort}
        sortColumn={sortColumn}
        data={
          [...one.TracibilityLogs].sort((a, b) => a.DateTime.localeCompare(b.DateTime)) 

        }
        />
       
        </div>)
        
    )}
    </div>
    </>
  );
};

export default TracibilityReport1;



